import { z } from 'zod';
export var NumericDiagnostic = z.object({
    type: z.enum([
        'UNKNOWN',
        'BECK',
        'PHQ9',
        'SCS',
        'BSCS'
    ]).prefault('UNKNOWN'),
    occurrenceDate: z.string().prefault(''),
    responses: z.array(z.number()).prefault([])
}).prefault({
    occurrenceDate: '',
    responses: [],
    type: 'UNKNOWN'
});
